import ModalWindow from 'components/ModalWindow';
import React, { useState } from 'react';
import AdPlayer from './AdPlayer';
import { sendTracking } from 'helpers';

const AdPlayerModal = ({ isOpened, handleClose, videoUrl, adUrl, trackingEvents, clickLogUrl }) => {
    const [resetPlayback, setResetPlayback] = useState(null);

    const handleModalClose = (e) => {
        e?.stopPropagation()
        if (resetPlayback) {
            resetPlayback(); // 비디오 초기화
        }
        handleClose();
    };

    const handlePlayerClick = () => {
        if (!isOpened) {
            return;
        }

        window.open(adUrl);
        sendTracking(clickLogUrl);
    }

    return (
        <ModalWindow 
            open={isOpened} 
            onClose={handleClose} 
            focusTrapped={false}  
            classNames={{
                overlay: "_Modal_UI_Wrap dimed",
                modal: "modal_modal_style ui-pop-m bs-layer flex_box",
            }}
        >
            {() => (
                <>
                    <div className="a_d_player_layer" onClick={handlePlayerClick}>
                        <AdPlayer
                            videoUrl={videoUrl}
                            onReset={setResetPlayback}
                            onVideoEnd={handleModalClose}
                            trackingEvents={trackingEvents}
                        />
                        <button type="button" className="close" onClick={handleModalClose}>
                            닫기
                        </button>
                    </div>
                </>
            )}
        </ModalWindow>
    );
};

export default AdPlayerModal;